import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';

import * as ActivateInvitationActions from '../actions/activate-invitation.actions';
import {AuthService} from '../../../../services/api/auth.service';


@Injectable()
export class ActivateInvitationEffects {

  // noinspection JSUnusedGlobalSymbols
  activateInvitation$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(ActivateInvitationActions.activateInvitation),
        concatMap((payload) =>
          this.authService.activateInvitation(payload.data)
            .pipe(
              map(data => ActivateInvitationActions.activateInvitationSuccess({data})),
              catchError(error => of(ActivateInvitationActions.activateInvitationFailure({error})))
            )
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly authService: AuthService
  ) {
  }

}
